import { Injectable, ViewContainerRef } from "@angular/core";
import { ToastsManager } from "ng2-toastr";

@Injectable()
export class CommonService{
    public noRecordMsg:string='They are no record!';
    public dataCreation:string='User has been updated Successfully';
    public dataUpdation:string='User has been created Successfully';
    constructor(public toastr: ToastsManager){}

    public setToastrRootViewContainerRef(vcr: ViewContainerRef): void {
        this.toastr.setRootViewContainerRef(vcr);
    }

    public showSuccessMessage(message: string, toastr?: ToastsManager): void {
        if (toastr) {
            toastr.success(message, 'Success');
        } else {
            this.toastr.success(message, 'Success');
        }
    }

    public showErrorMessage(message: string, toastr?: ToastsManager): void {
        if (toastr) {
            toastr.error(message, 'Error');
        } else {
            this.toastr.error(message, 'Error');
        }
    }

    public showInformationMessage(message: string, toastr?: ToastsManager): void {
        if (toastr) {
            toastr.info(message, 'Information');
        } else {
            this.toastr.info(message, 'Information');
        }
    }
}


// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/services/apiservices/common.service.ts